/*=============================================== TagPage ===============================================*/

import { Tag, Flexbox } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const TagPage = () => {
    const items: ItemType[] = [
        {
            title: "Plain",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Tag color="primary" icons={{ left: "chevron-right" }}>
                        Tag
                    </Tag>
                    <Tag color="secondary">Tag</Tag>
                    <Tag color="success">Tag</Tag>
                    <Tag color="danger">Tag</Tag>
                    <Tag color="warning">Tag</Tag>
                    <Tag color="gray">Tag</Tag>
                    <Tag color="black">Tag</Tag>
                    <Tag color="white">Tag</Tag>
                    <Tag color="background">Tag</Tag>
                    <Tag color="font">Tag</Tag>
                </Flexbox>
            ),
            code: '<Tag color="primary" icons={{ left: "chevron-right" }}>Tag</Tag>\n<Tag color="secondary">Tag</Tag>\n<Tag color="success">Tag</Tag>\n<Tag color="danger">Tag</Tag>\n<Tag color="warning">Tag</Tag>\n<Tag color="gray">Tag</Tag>\n<Tag color="black">Tag</Tag>\n<Tag color="white">Tag</Tag>\n<Tag color="background">Tag</Tag>\n<Tag color="font">Tag</Tag>',
        },
        {
            title: "Outline",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Tag
                        color="primary"
                        icons={{ left: "chevron-right" }}
                        variant="outline"
                    >
                        Tag
                    </Tag>
                    <Tag color="secondary" variant="outline">
                        Tag
                    </Tag>
                    <Tag color="success" variant="outline">
                        Tag
                    </Tag>
                    <Tag color="danger" variant="outline">
                        Tag
                    </Tag>
                    <Tag color="warning" variant="outline">
                        Tag
                    </Tag>
                    <Tag color="gray" variant="outline">
                        Tag
                    </Tag>
                    <Tag color="black" variant="outline">
                        Tag
                    </Tag>
                    <Tag color="white" variant="outline">
                        Tag
                    </Tag>
                    <Tag color="background" variant="outline">
                        Tag
                    </Tag>
                    <Tag color="font" variant="outline">
                        Tag
                    </Tag>
                </Flexbox>
            ),
            code: '<Tag color="primary" icons={{ left: "chevron-right" }} variant="outline">Tag</Tag>\n<Tag color="secondary" variant="outline">Tag</Tag>\n<Tag color="success" variant="outline">Tag</Tag>\n<Tag color="danger" variant="outline">Tag</Tag>\n<Tag color="warning" variant="outline">Tag</Tag>\n<Tag color="gray" variant="outline">Tag</Tag>\n<Tag color="black" variant="outline">Tag</Tag>\n<Tag color="white" variant="outline">Tag</Tag>\n<Tag color="background" variant="outline">Tag</Tag>\n<Tag color="font" variant="outline">Tag</Tag>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "variant",
            type: "string",
            possible: ["plain", "outline"],
            default: "plain",
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsShort,
            default: "primary",
        },
        "separator",
        {
            subtitle: "icons",
            type: "object",
        },
        {
            title: (
                <>
                    <code>icons</code> object
                </>
            ),
            subtitle: "left",
            intro: commonProps.addIconCapital,
            type: "string",
        },
        {
            subtitle: "right",
            type: "string",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default TagPage
